export default __webpack_public_path__ + "static/5905v5907_2-bb1c4a9a0123429fbe94e75dc5699434.png";